import $ from 'jquery';
import Masonry from 'masonry-layout';
import slick from 'slick-carousel';

export default () => {
  if ($('body[data-backend]').length > 0 && $('.js-publication-box').length > 0) {
    filterPublicationsAjax();
  }

  $(document).ready(function () {
    if ($('.publications-list').length > 0) {
      var msnry = new Masonry('.publications-list', {
        itemSelector: '.publications-list__item',
        gutter: 0
      });
    }

    let firstSliderInit = true;
    if ($('.publications-slider').length > 0) {
      const isRtl = $('html').attr('dir') === 'rtl' ? true : false;

      var $publicationsSlider = $('.publications-slider'),
        $publicationsSliderStatus = $('.publications-slider__status');

      $publicationsSlider.on('init reInit beforeChange', function (event, slick, currentSlide, nextSlide) {
        var i = 0;
        if (currentSlide  && currentSlide > nextSlide) {
          i = currentSlide;
        }
        else if (firstSliderInit === true) {
         i = (currentSlide ? currentSlide : 0) + 1;
        }
        else {
         i = (currentSlide ? currentSlide : 0) + 2;
        }

        $publicationsSliderStatus.html('<strong>' + 0 + i + '</strong>' + 0 + $('.publications-slider__item').length);
        firstSliderInit = false;
      });

      $publicationsSlider.slick({
        rtl: isRtl,
        infinite: false,
        adaptiveHeight: true,
        autoplay: true,
        autoplaySpeed: 10000,
        fade: true,
        speed: 650
      });
    }
  });

  function filterPublicationsAjax() {
    let alreadyFiltered = false;

    if ($('.js-publication-box #publication-id').length > 0) {
      $('.js-publication-box #publication-id').on('change', function () {
        publicationFilter();
      });
    }

    $(document).on('click', '.load-more', function () {
      publicationFilter(false);
    });

    $('.js-publication-box #publication-year').on('change', function () {
      publicationFilter();
    });

    let time;
    $('.js-publication-box #publication-search').on('change paste keyup', function () {
      let value = $(this).val();
      if (time !== null) {
        clearTimeout(time);
      }
      time = setTimeout(function () {
        if (value.length > 3 || alreadyFiltered === true) {
          alreadyFiltered = false;
          publicationFilter();
        }
      }, 500);
    });

    let isRtl = $('html').attr('dir') === 'rtl';
    let apiUrl = '/api/publicationsService/GetItems';
    let itemsPerPage = $('#publications-items-per-page');
    let pageNumber = $('#publications-page-number');
    let preselectedPublicationTypeIds = $('#publications-ids').val();
    let enablePublicationType = $('.publications-list').attr('data-enable-publication-type');
    let culture = 'en';
    if (isRtl) {
      culture = 'ar';
    }

    publicationFilter();

    function publicationFilter(clearCurrent) {
      if (clearCurrent !== false) {
        clearCurrent = true;
      }
      if (clearCurrent) {
        if ($('.load-more').length > 0) {
          $('.load-more').remove();
        }
        if ($('.publications-list__item').length > 0) {
          $('.publications-list__item').remove();
        }
        pageNumber.val(0);
      } else {
        if (!isRtl) {
          $('.js-load-more-gallery').text('LOADING ...');
        } else {
          $('.js-load-more-gallery').text('جاري التحميل ...');
        }
      }

      let take = parseInt(itemsPerPage.val());
      let skip = take * parseInt(pageNumber.val());

      let publicationId = '';

      if ($('.js-publication-box #publication-id').length > 0) {
        publicationId = $('.js-publication-box #publication-id').val();
      }

      let year = $('.js-publication-box #publication-year').val();
      let searchText = $('.js-publication-box #publication-search').val();

      if (searchText.length > 3) {
        alreadyFiltered = true;
      }

      if (publicationId != '' && year != '') {
        $('[data-year]').hide();
        $('[data-year="' + year + '"]').show();
        $('[data-years]').hide();
        $('[data-years="' + year + '"]').show();
      } else if (publicationId != '') {
        var dataYear = $('.js-publication-box #publication-id option:selected').attr('data-years');
        $('[data-year]').hide();
        $('[data-year="' + dataYear + '"]').show();
      } else if (year != '') {
        $('[data-years]').hide();
        $('[data-years="' + year + '"]').show();
      } else if (publicationId == '' && year == '') {
        $('[data-year]').show();
        $('[data-years]').show();
      }

      $.get(apiUrl, {
        culture,
        searchText,
        publicationId,
        year,
        preselectedPublicationTypeIds,
        skip,
        take,
      }).done((data) => {
        let htmlToAdd = '';
        let count = 0;

        if  (data.Items.length == 0) {
          $('.js-not-found').show();
          return;
        }
        else {
          $('.js-not-found').hide();
        }

        data.Items.forEach((publication) => {
          if (!publication.Summary) {
            publication.Summary = '';
          }

          let publicationWithImageNormalWidthHtml = $('#publication-item-with-image-normal-width').html();
          let publicationItemWithImageFullWidthHtml = $('#publication-item-with-image-full-width').html();
          let publicationItemNoImageHtml = $('#publication-item-no-image').html();

          let publicationType = '';
          let showPublicationType = false;
          if (enablePublicationType && enablePublicationType.toLowerCase() == 'true') {
            showPublicationType = true;
          }

          publicationType = publication.PublicationType;

          if (publication.Template == "Image" && publication.Image != null) {
            if (publicationType.toLowerCase() == 'article' && count == 4) {
              htmlToAdd += getPublicationItemWithImageHtml(publicationItemWithImageFullWidthHtml, publication, showPublicationType, publicationType);
            } else {
              htmlToAdd += getPublicationItemWithImageHtml(publicationWithImageNormalWidthHtml, publication, showPublicationType, publicationType);
            }

          } else {
            htmlToAdd += getPublicationItemHtmlWithoutImage(publicationItemNoImageHtml, publication, showPublicationType, publicationType);
          }

          if (count == 4) {
            count = 0;
          } else {
            count += 1;
          }
        });

        if ($('.publications-list__item').length == 0) {
          $('.publications-list').append(htmlToAdd);
        } else {
          $('.publications-list__item').last().after(htmlToAdd);
        }

        let itemsCount = $('.publications-list__item').length;
        var loadMoreText = '';
        if (!isRtl) {
          loadMoreText = 'Load More';
        } else {
          loadMoreText = 'عرض المزيد';
        }

        if (itemsCount < data.TotalCount) {
          if ($('.load-more').length > 0) {
            $('.load-more').remove();
          }
          let loadMoreTemplateHtml = $('#js-slider-load-more-template').html();
          loadMoreTemplateHtml = loadMoreTemplateHtml.replace(/\[\[loadMore\]\]/g, loadMoreText);
          $('.publications-list__holder').after(loadMoreTemplateHtml);
        } else {
          if ($('.load-more').length > 0) {
            $('.load-more').remove();
          }
        }

        let currentPageNumber = parseInt(pageNumber.val());
        currentPageNumber++;
        pageNumber.val(currentPageNumber);
        var msnry = new Masonry('.publications-list', {
          itemSelector: '.publications-list__item',
          gutter: 0
        });

        let $publicationLink = $('.publication__link').each(function () {
          let $publicationBody = $(this).closest('.publication__body');
          $publicationBody.find('.publication__title a').attr('href', $(this).attr('href'));

        });
      });

      function getPublicationItemHtmlWithoutImage(html, publication, showPublicationType, publicationType) {
        html = html.replace(/\[\[Title\]\]/g, publication.Heading)
          .replace(/\[\[Date\]\]/g, publication.PublicationDate);
          html = html.replace(/\[\[Summary\]\]/g, publication.Summary);

        if (showPublicationType) {
          html = html.replace(/\[\[Tag\]\]/g, publicationType);
        }

        let linkHtml = getPublicationLink(publication);

        if (linkHtml) {
          html = $(html).find('.publication__body').append(linkHtml).closest('.publications-list__item')[0].outerHTML;
        }

        return html;
      }

      function getPublicationLink(publication) {
        let publicationLinkHtml = $('#link-read-more').html();
        let publicationDownloadLinkHmtl = $('#link-download').html();

        let showDocument = false;
        let showLink = false;
        if (publication.LinkedUrl != null && publication.LinkedUrl != '') {
          showLink = true;
        } else if (publication.DocumentUrl != null && publication.DocumentUrl != '') {
          showDocument = true;
        }

        let linkHtml = '';
        if (showDocument) {
          linkHtml = publicationDownloadLinkHmtl.replace(/\[\[Link\]\]/g, publication.DocumentUrl);
        } else if (showLink) {
          linkHtml = publicationLinkHtml.replace(/\[\[Link\]\]/g, publication.LinkedUrl);
        }

        return linkHtml;
      }

      function getPublicationItemWithImageHtml(html, publication, showPublicationType, publicationType) {
        html = html.replace(/\[\[Img\]\]/g, publication.Image.ImageUrl)
          .replace(/\[\[Title\]\]/g, publication.Heading)
          .replace(/\[\[Date\]\]/g, publication.PublicationDate);

        if (showPublicationType) {
          html = html.replace(/\[\[Tag\]\]/g, publicationType);
        }
        
        html = html.replace(/\[\[Summary\]\]/g, publication.Summary);

        let linkHtml = getPublicationLink(publication);

        if (linkHtml) {
          html = $(html).find('.publication__body').append(linkHtml).closest('.publications-list__item')[0].outerHTML;
        }

        return html;
      }
    }
  }
}
